import { Input } from '@chiroup/components/form/Input';
import { SurveyQuestionAnswer } from '@chiroup/core/types/Survey.type';
import React, { useState } from 'react';
import { questionContentVerbiage } from './SurveyQuestionContent';

type Props = {
  id: string;
  onSelect: (val: SurveyQuestionAnswer) => Promise<void>;
  disabled: boolean;
  language?: 'en' | 'es';
  type?: string;
  primaryColor: string;
  hideNext?: boolean;
};

export const SurveyQuestionInput: React.FC<Props> = ({
  id,
  onSelect,
  disabled,
  language = 'en',
  type = 'text',
  primaryColor,
  hideNext = false,
}) => {
  const [val, setVal] = useState<string>('');

  // Inside a group there is no per-question Next button, so stream the value up
  // as the patient types — otherwise the group's single submit never receives
  // it. Emit even when empty so clearing the field propagates too.
  const onChange = async (next: string) => {
    setVal(next);
    if (hideNext) {
      await onSelect({ type: 'input', value: next });
    }
  };

  const handleSubmit = async () => {
    await onSelect({ type: 'input', value: val });
    setVal('');
  };

  return (
    <>
      <Input
        name={`question-${id}`}
        className=""
        value={val}
        onChange={onChange}
        disabled={disabled}
        type={type}
        autoFocus
      />
      {!hideNext && (
        <button
          disabled={!val || disabled}
          onClick={handleSubmit}
          className="cursor-pointer rounded-md shadow items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white hover:opacity-90 focus:outline-none focus:ring transition duration-150 ease-in-out mt-8"
          style={{
            backgroundColor: primaryColor,
          }}
        >
          {questionContentVerbiage[language === 'es' ? 'es' : 'en'].next}
        </button>
      )}
    </>
  );
};
